import TimePicker from "./TimePicker";
import { withStyles } from "@material-ui/core";
import WithRowLabel from "./WithRowLabel";

const styles = () => ({
  inputRoot: {
    height: 32,
    borderRadius: "4px",
    width: 100,
  },
  dateTimeContainer: {
    marginTop: 0,
  },
  dateWidth: {
    minWidth: 125,
  },
});

const StyledDateTimeEditor = withStyles(styles)(TimePicker);
const DateTimeEditorWithLabel = WithRowLabel(StyledDateTimeEditor);

export { StyledDateTimeEditor, DateTimeEditorWithLabel };
